/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Confirm_DeliveryInputs */

const vi_order_action_confirm_delivery = /** @type {(inputs: Order_Action_Confirm_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận đã giao`)
};

/**

* @param {Order_Action_Confirm_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_confirm_delivery = /** @type {((inputs?: Order_Action_Confirm_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Confirm_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_confirm_delivery(inputs)
});